import { styled } from 'styled-components';
import { Section } from '../..';
export const Wrapper = styled(Section) `
  padding: 8px 0px;
`;
